import React from 'react';
import { cn } from './cn';

function Shimmer({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-xl bg-surface-overlay/35',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.2s_infinite]',
        'before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent',
        className,
      )}
    />
  );
}

export type LoadingSkeletonProps = {
  variant?: 'card' | 'list' | 'text';
  lines?: number;
  className?: string;
};

export function LoadingSkeleton({ variant = 'text', lines = 3, className }: LoadingSkeletonProps) {
  if (variant === 'card') {
    return (
      <div className={cn('rounded-2xl border border-surface-border bg-surface-card/45 p-4', className)}>
        <Shimmer className="h-4 w-28" />
        <Shimmer className="mt-3 h-3 w-full" />
        <Shimmer className="mt-2 h-3 w-5/6" />
      </div>
    );
  }

  if (variant === 'list') {
    return (
      <div className={cn('rounded-2xl border border-surface-border bg-surface-card/45', className)}>
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className={cn('flex items-center gap-3 px-4 py-3', i > 0 && 'border-t border-surface-border')}>
            <Shimmer className="h-10 w-10 rounded-xl" />
            <div className="flex-1">
              <Shimmer className="h-3 w-40" />
              <Shimmer className="mt-2 h-3 w-24" />
            </div>
            <Shimmer className="h-3 w-12" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Shimmer key={i} className={cn('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}

